<template>
    <va-select
    :label="$t('catalog.category.parentCategory')"
    v-model="selectedCat"
    textBy="description"
    :options="options"
    :error="error"
    />     
</template>

<script>
export default {
    props: ['selected','currentCat'],
    data() {
        return {
            error:false,
            selectedCat: {},
            filteredOptions: null
        }
    },
    created(){
        if(this.options.length == 0){
            this.$store.dispatch('getCategories');  
        }
    },
    computed:{
        options(){
            return this.filteredOptions ? this.filteredOptions : this.$store.state.categories.selectOptions;
        },
        expandedOpt(){
            return this.$store.state.categories.expandedOptions;
        },
        categories(){
            return this.$store.state.categories.categories;
        },
    },
    watch: {
        selectedCat(t,f){
            this.$emit('update', t.id);
        },
        selected(t,f){
            if(t){
                this.selectedCat = this.expandedOpt[t];
            }
        },
        async currentCat(t,f){
            if(t){
                this.filteredOptions =  await this.$store.dispatch('buildCats', {cats: this.categories, excludedUuid: t});
            }
        }
    },
}
</script>
